import React from "react";
import {Skeleton, Stack} from "@mui/material";
import {observer} from "mobx-react-lite";
import type {MainComponentBaseProps} from "../RootTypes.ts";
import {HeaderAlert} from "../alerts/HeaderAlert.tsx";
import {DevopsMenu} from "../devops/DevopsMenu.tsx";
import {SelectDataset} from "./SelectDataset.tsx";
import {SingleDropdownMenu} from "~/pages/default-menus/SingleDropdownMenu.tsx";
import {useStores} from "~/stores/index.tsx";
import {PageHeaderSlotContext} from "~/components/main/header/PageHeaderSlotContext.ts";

/**
 * Mithra 3.1 header: [back · page title] · [data bag · account].
 * The left side is filled by the page through PageHeader. A page that needs a data bag is only shown once
 * it has loaded, so until then the title's place and the account menu show skeletons.
 */
export const MainHeader: React.FC<MainComponentBaseProps> = observer(({state}) => {
    const {p, bagStore, bagLoadingStore} = useStores();
    const {setSlot} = React.useContext(PageHeaderSlotContext);
    // Only pages that say what they need (SIT passes no state and loads no data bag).
    const pageWaitsForBag = !!state && state.dataType !== 'no_data' && !bagStore.bag && !bagLoadingStore.bagNotFound;

    return <Stack direction="row" alignItems="center" gap={1.5} sx={{width: '100%', minWidth: 0}}>
        <Stack ref={setSlot} direction="row" alignItems="center" sx={{minWidth: 0, maxWidth: '50%'}}/>
        {pageWaitsForBag && <Skeleton variant="text" width={180} sx={{fontSize: 17}}/>}
        <HeaderAlert/>
        <Stack sx={{flexGrow: 1}}/>
        {p.p.branding === 'NExO' && <img src="/logo/NExO_logo_v4_02_h60.png" height={24} alt="NExO" className="nexo-logo"/>}
        <SelectDataset/>
        {/* The account menu (for everyone) waits with the page; the staff menus show as they are. */}
        {pageWaitsForBag
            ? <Skeleton variant="circular" width={32} height={32} sx={{mx: 0.5}}/>
            : <SingleDropdownMenu/>}
        <DevopsMenu/>
    </Stack>
})
